import { css } from 'lit';

export const projectGridStyles = css`
  :host {
    display: block;
  }

  .projects-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .project-card {
    background: var(--bg-card, #ffffff);
    border: 1px solid var(--border-color, #e5e5de);
    border-radius: 6px;
    padding: 1.25rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .project-card:hover {
    border-color: var(--accent-color, #245590);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.5rem;
    margin-bottom: 0.4rem;
  }

  h3 {
    font-family: var(--font-serif, serif);
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--text-primary, #1a1a18);
    margin: 0;
  }

  .date {
    font-family: var(--font-mono, monospace);
    font-size: 0.8rem;
    color: var(--text-muted, #7c7c75);
  }

  .summary {
    font-size: 0.92rem;
    color: var(--text-secondary, #4a4a45);
    margin-bottom: 0.75rem;
    line-height: 1.55;
  }

  .tags-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    margin-bottom: 0.8rem;
  }

  .tag {
    font-family: var(--font-mono, monospace);
    font-size: 0.72rem;
    background-color: var(--bg-secondary, #f6f6f2);
    color: var(--text-secondary, #4a4a45);
    padding: 0.12rem 0.45rem;
    border-radius: 3px;
  }

  .actions {
    display: flex;
    gap: 1rem;
    font-size: 0.85rem;
  }

  .read-link {
    background: none;
    border: none;
    color: var(--accent-color, #245590);
    font-weight: 600;
    font-family: var(--font-sans);
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
  }

  .read-link:hover {
    text-decoration: underline;
  }

  .ext-link {
    color: var(--text-muted, #7c7c75);
    font-family: var(--font-mono, monospace);
    font-size: 0.8rem;
    text-decoration: none;
    border-bottom: 1px dotted var(--text-muted, #7c7c75);
  }

  .ext-link:hover {
    color: var(--accent-color, #245590);
    border-bottom-style: solid;
  }
`;
